import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/white_sedna_world_logo.svg")